import { observable } from 'mobx';
import type { CaseReportSectionTemplate, NestedLookupDto } from 'tm3-core/api.dtos';

export type TTemplate = (string | { sections: CaseReportSectionTemplate[] }) & {
  lists: Record<string, NestedLookupDto>;
  mandatoryFieldOverrides: Record<string, Record<string, boolean>>;
};

class ReportStore {
  @observable template: string | TTemplate = '';
  @observable sections = new Map();
  @observable reportTemplateType = 'M';
  @observable mode = '';
  @observable onStateChange = null;
  @observable data = {};

  applyValidation() {
    return Promise.resolve(true);
  }

  onExtract() {}
}

export default ReportStore;
